import { render } from "./TabbedPane.vue?vue&type=template&id=f3e75518"
import script from "./TabbedPane.vue?vue&type=script&lang=js"
export * from "./TabbedPane.vue?vue&type=script&lang=js"

import "./TabbedPane.vue?vue&type=style&index=0&id=f3e75518&lang=sass"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__